// src/pages/Company/AboutPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, Grid, Avatar, Stack } from '@mui/material';
import { Rocket, People, TrendingUp, Verified, School, EmojiEvents } from '@mui/icons-material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const AboutPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          About Rengigs
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Connecting organizations with innovative solutions and expert suppliers.
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>
            Our Mission
          </Typography>
          <Typography variant="body1" paragraph>
            To democratize access to industrial innovation by providing a transparent, efficient marketplace where organizations can find the right solutions and suppliers can grow their businesses.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>
            What We Do
          </Typography>
          <Typography variant="body1" paragraph>
            Rengigs is a B2B ecosystem that bridges the gap between organizations with technical challenges and suppliers/vendors with proven solutions. We facilitate problem posting, solution tagging, bidding, and subscription management – all in one place.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>
            Why Choose Rengigs?
          </Typography>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Stack alignItems="center" textAlign="center">
                <Avatar sx={{ bgcolor: RENGIGS.light, width: 64, height: 64, mb: 2 }}>
                  <Rocket sx={{ fontSize: 32, color: RENGIGS.green }} />
                </Avatar>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Fast Matching</Typography>
                <Typography variant="body2" color="text.secondary">AI-powered solution tagging</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Stack alignItems="center" textAlign="center">
                <Avatar sx={{ bgcolor: RENGIGS.light, width: 64, height: 64, mb: 2 }}>
                  <People sx={{ fontSize: 32, color: RENGIGS.green }} />
                </Avatar>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Trusted Network</Typography>
                <Typography variant="body2" color="text.secondary">Verified organizations & suppliers</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Stack alignItems="center" textAlign="center">
                <Avatar sx={{ bgcolor: RENGIGS.light, width: 64, height: 64, mb: 2 }}>
                  <TrendingUp sx={{ fontSize: 32, color: RENGIGS.green }} />
                </Avatar>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Business Growth</Typography>
                <Typography variant="body2" color="text.secondary">Access new markets & opportunities</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Stack alignItems="center" textAlign="center">
                <Avatar sx={{ bgcolor: RENGIGS.light, width: 64, height: 64, mb: 2 }}>
                  <Verified sx={{ fontSize: 32, color: RENGIGS.green }} />
                </Avatar>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Secure & Transparent</Typography>
                <Typography variant="body2" color="text.secondary">Stripe payments & data protection</Typography>
              </Stack>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>
            Our Values
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <School sx={{ color: RENGIGS.green }} />
                <Typography variant="body1">Innovation First</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <EmojiEvents sx={{ color: RENGIGS.green }} />
                <Typography variant="body1">Customer Success</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Verified sx={{ color: RENGIGS.green }} />
                <Typography variant="body1">Integrity & Transparency</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction="row" spacing={2} alignItems="center">
                <People sx={{ color: RENGIGS.green }} />
                <Typography variant="body1">Collaboration</Typography>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default AboutPage;